import { useState } from "react";
import { useHistory } from "react-router";
export default function useToken() {
    const history = useHistory()
    const getToken = () => {
        const tokenString = sessionStorage.getItem('token')
        const userToken = JSON.parse(tokenString)
        console.log(userToken)
        return userToken

    }

    const [token, setToken] = useState(getToken())
    const [isLoggedIn, setLoggedIn] = useState(token ? true : false)

    const saveToken = userToken => {
        sessionStorage.setItem('token', JSON.stringify(userToken))
        setToken(userToken)
        setLoggedIn(true)
    }

    const deleteToken = () => {
        sessionStorage.clear();
        setToken('')
        setLoggedIn(false)
        history.push('/login')
    }

    return {
        setToken: saveToken,
        token,
        isLoggedIn,
        deleteToken
    }
}